
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-6xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-gray-900">
              Pavane
            </Link>

            {/* 데스크톱 메뉴 */}
            <div className="hidden md:flex items-center space-x-8">
              <Link 
                to="/about" 
                className={`transition-colors duration-200 hover:text-teal-600 ${
                  isActive('/about') ? 'text-teal-600 font-semibold' : 'text-gray-700'
                }`}
              >
                About
              </Link>
              <Link 
                to="/illustrators" 
                className={`transition-colors duration-200 hover:text-teal-600 ${
                  isActive('/illustrators') ? 'text-teal-600 font-semibold' : 'text-gray-700'
                }`}
              >
                Illustrators
              </Link>
              <Link 
                to="/designers" 
                className={`transition-colors duration-200 hover:text-teal-600 ${
                  isActive('/designers') ? 'text-teal-600 font-semibold' : 'text-gray-700'
                }`}
              >
                Designers
              </Link>
              <Link 
                to="/writers" 
                className={`transition-colors duration-200 hover:text-teal-600 ${
                  isActive('/writers') ? 'text-teal-600 font-semibold' : 'text-gray-700'
                }`}
              >
                Writers
              </Link>
              <Link 
                to="/painters" 
                className={`transition-colors duration-200 hover:text-teal-600 ${
                  isActive('/painters') ? 'text-teal-600 font-semibold' : 'text-gray-700'
                }`}
              >
                Painters
              </Link>
              <Link 
                to="/contact" 
                className={`transition-colors duration-200 hover:text-teal-600 ${
                  isActive('/contact') ? 'text-teal-600 font-semibold' : 'text-gray-700'
                }`}
              >
                Contact
              </Link>
            </div>

            {/* 모바일 햄버거 메뉴 버튼 */}
            <button
              onClick={toggleMobileMenu}
              className="md:hidden p-2 text-gray-700 hover:text-teal-600 transition-colors duration-200"
              aria-label="메뉴 토글"
            >
              <div className="w-6 h-6 flex flex-col justify-center items-center">
                <span className={`block w-5 h-0.5 bg-current transition-all duration-300 ${
                  isMobileMenuOpen ? 'rotate-45 translate-y-0.5' : '-translate-y-1'
                }`}></span>
                <span className={`block w-5 h-0.5 bg-current transition-all duration-300 ${
                  isMobileMenuOpen ? 'opacity-0' : 'opacity-100'
                }`}></span>
                <span className={`block w-5 h-0.5 bg-current transition-all duration-300 ${
                  isMobileMenuOpen ? '-rotate-45 -translate-y-0.5' : 'translate-y-1'
                }`}></span>
              </div>
            </button>
          </div>
        </div>

        {/* 모바일 메뉴 */}
        <div className={`md:hidden bg-white border-t shadow-lg transition-all duration-300 ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
        }`}>
          <div className="px-6 py-4 space-y-4">
            <Link 
              to="/about" 
              className={`block py-2 transition-colors duration-200 hover:text-teal-600 ${
                isActive('/about') ? 'text-teal-600 font-semibold' : 'text-gray-700'
              }`}
            >
              About
            </Link>
            <Link 
              to="/illustrators" 
              className={`block py-2 transition-colors duration-200 hover:text-teal-600 ${
                isActive('/illustrators') ? 'text-teal-600 font-semibold' : 'text-gray-700'
              }`}
            >
              Illustrators
            </Link>
            <Link 
              to="/designers" 
              className={`block py-2 transition-colors duration-200 hover:text-teal-600 ${
                isActive('/designers') ? 'text-teal-600 font-semibold' : 'text-gray-700'
              }`}
            >
              Designers
            </Link>
            <Link 
              to="/writers" 
              className={`block py-2 transition-colors duration-200 hover:text-teal-600 ${
                isActive('/writers') ? 'text-teal-600 font-semibold' : 'text-gray-700'
              }`}
            >
              Writers
            </Link>
            <Link 
              to="/painters" 
              className={`block py-2 transition-colors duration-200 hover:text-teal-600 ${
                isActive('/painters') ? 'text-teal-600 font-semibold' : 'text-gray-700'
              }`}
            >
              Painters
            </Link>
            <Link 
              to="/contact" 
              className={`block py-2 transition-colors duration-200 hover:text-teal-600 ${
                isActive('/contact') ? 'text-teal-600 font-semibold' : 'text-gray-700'
              }`}
            >
              Contact
            </Link>
          </div>
        </div>
      </nav>

      {/* 모바일 메뉴 오버레이 */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 z-40 bg-black bg-opacity-25"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Navbar;
